import { useEffect } from "react"
import useLocalStorage from "Shared/hooks/useLocalStorage"
import { QueryParams } from "Shared/queries/consts"

type StorageState = Pick<QueryParams, "page" | "limit" | "search" | "sortParams">

export const useSetQueryParamsStorage = ({ page, limit, search, sortParams }: StorageState, storageKey: string) => {
    const [_, setState] = useLocalStorage<StorageState>(storageKey, {
        page,
        limit,
        search,
        sortParams,
    })
    useEffect(() => {
        setState({ page, limit, search, sortParams })
    }, [page, limit, search, sortParams])
}

export const useGetQueryParamsStorage = ({ storageKey }: { storageKey: string }) => {
    const [state] = useLocalStorage<StorageState>(storageKey, {})
    return state
}
